import type { components } from '~/types/napis'

export const isAuthorAdmin = (roles: components['schemas']['UserTypeChoice'][] = []): boolean => {
  if (roles.length === 0) {
    return false
  }
  return (
    roles.includes('COURSE_ADMIN') || roles.includes('TALENT_ADMIN') || roles.includes('JOB_ADMIN')
  )
}

export const isAuthorInstructor = (
  roles: components['schemas']['UserTypeChoice'][] = []
): boolean => {
  return roles.includes('INSTRUCTOR')
}

export const isTagClass = (tagName: string) => tagName === 'classroom'

export const areTagsClass = (tags: components['schemas']['TagResponseSchema'][]) => {
  if (!tags) return false
  for (const tag of tags) {
    if (tag.category && isTagClass(tag.category)) return true
  }
  return false
}

export const isPostClass = (post: components['schemas']['PostCommentReplyResponseSchema']) => {
  if (!post.tags) return false
  for (const tag of post.tags) {
    if (tag.category && isTagClass(tag.category.category_name || '')) return true
  }
  return false
}
